<form [formGroup]="userProfileForm">
  <div formArrayName="educations">
    <div
      *ngFor="let edu of educations.controls; let i = index"
      [formGroupName]="i"
      class="form-card mb-3"
    >
      <span (click)="removeEducation(i)" *ngIf="educations.length > 1">
        <i class="bi bi-trash-fill remove"></i>
      </span>

      <h3 class="section-title">
        <i class="bi bi-school"></i>

        Education {{ i + 1 }}
      </h3>

      <div class="form-grid">
        <div class="form-group">
          <label>College / University <span>*</span></label>
          <input
            type="text"
            formControlName="collegeName"
            placeholder="e.g. IIT Bombay"
          />
          <small class="text-danger smaller-text"
              *ngIf="(educations.at(i).get('collegeName')?.dirty || educations.at(i).get('collegeName')?.touched)
              && educations.at(i).get('collegeName')?.errors?.['required']">
              College name is required
            </small>

          <small class="text-danger smaller-text"
              *ngIf="(educations.at(i).get('collegeName')?.dirty || educations.at(i).get('collegeName')?.touched)
              && educations.at(i).get('collegeName')?.errors?.['invalidCollegeName']">
              Enter a valid college name
            </small>
        </div>

        <div class="form-group">
          <label>Location</label>
          <input
            type="text"
            formControlName="location"
            placeholder="e.g. Mumbai, India"
          />

           <small class="text-danger smaller-text" 
           *ngIf="userProfileForm.get('location')?.errors?.['invalidLocation']">
          Enter a valid location (only letters, numbers, commas)</small>

        </div>

        <div class="form-group">
          <label>Degree <span>*</span></label>
          <input
            type="text"
            formControlName="degree"
            placeholder="e.g. B.Tech"
          />
        <small class="text-danger smaller-text"
          *ngIf="(getControl(i, 'degree')?.dirty || getControl(i, 'degree')?.touched)
          && getControl(i, 'degree')?.errors?.['required']">
          Degree is required
        </small>

        <small class="text-danger smaller-text"
          *ngIf="(getControl(i, 'degree')?.dirty || getControl(i, 'degree')?.touched)
          && getControl(i, 'degree')?.errors?.['invalidDegree']">
          Enter a valid degree (e.g. B.Tech, MBA)
        </small>
        </div>

        <div class="form-group">
          <label>Specialization / Branch</label>
          <input
            type="text"
            formControlName="specialization"
            placeholder="e.g. Computer Science" />
        </div>

        <div class="form-group">
          <label>Start Date</label>
          <div class="date-row">
            <select formControlName="startMonth">
              <option value="" disabled selected hidden>Month</option>
              <option *ngFor="let m of months">{{ m }}</option>
            </select>
            <select formControlName="startYear">
              <option value="" disabled selected hidden>Year</option>
              <option *ngFor="let y of years" [value]="y.toString()">{{ y }}</option>
            </select>
          </div>
        </div>

        <div class="form-group">
          <label>End Date</label>
          <div class="date-row">
            <select formControlName="endMonth">
              <option value="" disabled selected hidden>Month</option>
              <option value="Present" *ngIf="isCurrentlyStudying(i)">
                Present
              </option>

              <ng-container *ngIf="!isCurrentlyStudying(i)">
                <option *ngFor="let m of months" [value]="m">{{ m }}</option>
              </ng-container>
            </select>
            <select
              formControlName="endYear"
              [disabled]="isCurrentlyStudying(i)">
              <option value="" disabled selected hidden>Year</option>
              <option *ngFor="let y of years" [value]="y.toString()">{{ y }}</option>
            </select>
          </div>
          <div class="checkbox">
            <input
              type="checkbox"
              formControlName="currently_studying"
              (change)="onCurrentlyStudyingChange($event, i)"
            />Currently pursuing
          </div>
            <div class="text-danger smaller-text"
            *ngIf="educations.at(i).errors?.['invalidDateRange'] &&
            (getControl(i, 'endMonth')?.touched || getControl(i, 'endYear')?.touched)">
            End date cannot be earlier than start date
          </div>
        </div>

        <div class="form-group">
          <label>CGPA / Percentage</label>
          <input
            type="text"
            formControlName="cgpa_or_percentage"
            placeholder="e.g. 8.5 or 85%"
          />
          <small class="text-danger smaller-text"
          *ngIf="(getControl(i, 'cgpa_or_percentage')?.dirty || getControl(i, 'cgpa_or_percentage')?.touched)
          && getControl(i, 'cgpa_or_percentage')?.errors?.['invalidCgpa']">
          Enter valid CGPA or percentage (e.g. 8.5 or 85%)
        </small>
        </div>
      </div>
    </div>
  </div>

  <button type="button" class="add-btn" (click)="addEducation()">
    + Add Another Education
  </button>
</form>
